import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { SMLRouteNames } from './SMLRoutes';
import { takeSignupLandingRoute } from '../../modules/onboarding/signupLanding';
import { smlRoutePath } from './smlRoutePath';

/** A plain `/app` or `/app/` opens the artist Home. The Stripe return opens its own page. */
export const SMLRootRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const subscriptionSuccess = searchParams.get('subscription_success');

  if (subscriptionSuccess === 'true') {
    return <Navigate to={SMLRouteNames.paymentComplete} replace />;
  }

  // A signup from music24.com/pitch opens Outreach → Pitch once (`signupLanding.ts`).
  const landing = takeSignupLandingRoute();
  return <Navigate to={landing === null ? SMLRouteNames.home : `/${smlRoutePath(landing)}`} replace />;
};
